import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content;
}

const httpLink = new HttpLink({
  uri: '/graphql',
  credentials: 'include'
});

// Attach the CSRF token before the request goes out, so the link must run
// before httpLink (links execute in array order; httpLink is terminal).
const csrfLink = new ApolloLink((operation, forward) => {
  const token = getCsrfToken();
  if (token) {
    operation.setContext(({ headers = {} }) => ({
      headers: { ...headers, 'X-CSRF-Token': token }
    }));
  }
  return forward(operation);
});

const authLink = ApolloLink.from([csrfLink, httpLink]);

export const apolloClient = new ApolloClient({
  link: authLink,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          graves: { merge: false },
          figures: {
            keyFields: false,
            merge(existing, incoming) {
              return incoming;
            }
          }
        }
      },
      FigureStore: {
        keyFields: false,
        fields: {
          figures: {
            merge(existing, incoming) {
              return incoming || {};
            },
            read(figures) {
              return figures || {};
            }
          }
        }
      }
    }
  })
});
